module.exports = __webpack_public_path__ + "static/media/openai.5bfb83a8.webp";